/**
 * The Popup Motion logo.
 *
 * Two lockups: the full one (mark plus wordmark) and the wordmark on its own,
 * which is what fits a narrow app sidebar. Each has a white version for the
 * dark bands, the footer and the auth panel, because a PNG cannot be recoloured
 * with currentColor the way the old inline SVG could.
 *
 * Intrinsic width and height are always set so the browser reserves the box
 * before the file arrives. The nav sits at the very top of the page, so a logo
 * that reflows on load moves everything under it.
 */

const ART = {
  full: { src: '/logo-full.png', light: '/logo-full-light.png', w: 1200, h: 171 },
  wordmark: { src: '/logo-wordmark.png', light: '/logo-wordmark-light.png', w: 1000, h: 129 },
  mark: { src: '/logo-mark.png', light: '/logo-mark-light.png', w: 512, h: 512 },
}

export default function Logo({ className = 'h-8', inverted = false, variant = 'full', alt = 'Popup Motion' }) {
  const art = ART[variant] ?? ART.full
  return (
    <img
      src={inverted ? art.light : art.src}
      width={art.w}
      height={art.h}
      alt={alt}
      decoding="async"
      className={'w-auto select-none ' + className}
    />
  )
}
